module.exports = __webpack_public_path__ + "static/media/EasyCall-in-logo.3aea5758.svg";